import React from 'react'

export default function () {
  return (<div>Active site</div>)
}



// WEBPACK FOOTER //
// ./src/pages/site-manager/active-site/index.js